




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Autocomplete extends Vue {
  @Prop() readonly items!: Array<object>;
  @Prop() readonly searchResult!: string;

  mounted() {
    console.log(this.items);
  }
}
